import 'whatwg-fetch';
import {history} from '../../router/history';
import {
    setApplicationForAdmission,
    add_msg,
} from '../../actions'
import fetchConfig from '../fetchConfig'
import SystemModal from '../SystemModal/SystemModal'
import fetchExtend from '../fetchExtend'

export default {
    edit: (dispatch) => {
        SystemModal.showLoadMsg(dispatch)
        fetch(API_SERVER+'/api/v1/application_for_admissions/0/edit', {
            credentials: 'same-origin',
            method: 'GET',
            headers:  new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                console.log('獲取編輯數據:', json);
                dispatch(setApplicationForAdmission(json))
                SystemModal.closeMsg(dispatch)
            })
            .catch((error) => {
                fetchExtend.postError(error)
                SystemModal.showLoadErrorMsg(dispatch)
            })
    },
    get: (dispatch) => {
        SystemModal.showLoadMsg(dispatch)
        fetch(API_SERVER+'/api/v1/application_for_admissions/0.json', {
            credentials: 'same-origin',
            method: 'GET',
            headers: new fetchConfig().fetchConfigHeaders()
        }).then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                console.log('獲取圖片資料:', json);
                
                // 檢查數據中是否包含圖片URL
                if (json && json.stud_img_url) {
                    console.log('成功獲取圖片URL:', json.stud_img_url);
                } else {
                    console.warn('獲取的數據中沒有包含stud_img_url');
                }
                
                dispatch(setApplicationForAdmission(json))
                SystemModal.closeMsg(dispatch)
            })
            .catch((error) => {
                console.error('獲取圖片資料失敗:', error);
                fetchExtend.postError(error)
                SystemModal.showLoadErrorMsg(dispatch)
            })
    },
    update: (dispatch,payload) => {
        SystemModal.showSaveMsg(dispatch)
        let payloadValue = payload.toJS();
        if (payloadValue.ques_check) {
            SystemModal.closeMsg(dispatch)
            dispatch(add_msg('入學申請書已鎖定，請聯繫註冊組開啟後再修改', 'error'))
            return
        }
        let formData = new FormData();
        for (var key in payloadValue){
            formData.append("application_for_admission[" + key + "]", payloadValue[key]);
        }
        if (typeof(payloadValue.stud_img_url) === 'object'){
            formData.append("application_for_admission[stud_img]", payloadValue.stud_img_url[0]);
        } else {
            formData.delete("application_for_admission[stud_img]");
        }

        fetch(API_SERVER+'/api/v1/application_for_admissions/0.json', {
            credentials: 'same-origin',
            method: 'PATCH',
            headers:  new fetchConfig().fetchConfigHeaders(),
            body: formData
            // body: JSON.stringify( { transfer_student: payloadValue } )
        })
            .then(function (response) {
                if (response.status === 401) {
                    var error = new Error(response.statusText)
                    error.response = response.json()
                    throw error
                }
                return response.json()
            })
            .then(function (json) {
                SystemModal.closeMsg(dispatch)
                dispatch(add_msg('儲存完成'));
                history.push('/devise_dashboard');

            })
            .catch(function (error) {
                SystemModal.showSaveErrorMsg(dispatch)
            });
    },
    uploadStudImg: (dispatch, payload) => {
        SystemModal.showSaveMsg(dispatch);
        
        try {
            if (!payload || !Array.isArray(payload) || payload.length === 0) {
                throw new Error('請選擇要上傳的圖片');
            }

            const file = payload[0];
            // 驗證圖片
            if (!file.type.match(/^image\/(jpeg|png|gif)$/)) {
                throw new Error('請上傳 JPG、PNG 或 GIF 格式的圖片');
            }

            // 檢查檔案大小（限制為 20MB）
            if (file.size > 20 * 1024 * 1024) {
                throw new Error('圖片大小不能超過 20MB');
            }
            
            console.log('開始上傳學生圖片:', file.name);
            
            let formData = new FormData();
            // 將檔案轉換為 blob
            const blob = new Blob([file], { type: file.type });
            formData.append("application_for_admission[stud_img]", blob, file.name);
            
            // 使用更簡潔的URL拼接方式
            const apiUrl = `${API_SERVER}/api/v1/application_for_admissions/0.json`;
            
            fetch(apiUrl, {
                credentials: 'same-origin',
                method: 'PATCH',
                headers: new fetchConfig().fetchConfigHeaders(),
                body: formData
            })
            .then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                SystemModal.closeMsg(dispatch);
                console.log('學生照片上傳成功，伺服器回應:', json);
                
                // 顯示成功信息
                dispatch(add_msg('照片上傳成功'));
                
                // 直接返回獲取編輯數據的接口 (類似ParentPass.jsx的實現)
                return fetch(`${API_SERVER}/api/v1/application_for_admissions/0/edit`, {
                    credentials: 'same-origin',
                    method: 'GET',
                    headers: new fetchConfig().fetchConfigHeaders(),
                    cache: 'no-store'
                });
            })
            .then(fetchExtend.checkStatus)
            .then(fetchExtend.parseJSON)
            .then((json) => {
                console.log('獲取到更新後的學生數據:', json);
                
                // 更新到Redux store
                dispatch(setApplicationForAdmission(json));
            })
            .catch(function (error) {
                console.error('上傳或重新獲取資料時出錯:', error);
                throw error;
            });
        } catch (error) {
            console.error('上傳照片失敗:', error);
            SystemModal.closeMsg(dispatch);
            dispatch(add_msg(error.message || '照片上傳失敗，請確認圖片格式正確且大小適中'));
            SystemModal.showSaveErrorMsg(dispatch);
        }
    },
}



// WEBPACK FOOTER //
// ./src/dashboards_redux/utils/ApplicationForAdmission/ApplicationForAdmission.jsx